import * as t from "react";
var a = globalThis != null && globalThis.document ? t.useLayoutEffect : () => {
};
export {
  a as u
};
//# sourceMappingURL=index-DuekHEmj.js.map
